import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {IFetchOrderContractsParams} from '../../api/modules/master-data/types'
import {RootState} from '../../store'
import {TOrderItemContract, TOrderSubDetail} from '../types'

/** @deprecated gunakan IFetchOrderContractsParams */
export interface IFilter {
  contract_number?: string
  sip_number?: string
  from_date?: string
  to_date?: string
  customer_name?: string
  total_quantum?: string
  product_type?: string
  total_price?: string
  payment_type?: string
  estimate_date?: string
  status?: string
  regarding?: string
  sector_id?: string
  po_number?: string
  sap_number?: string
  sales_org_code?: string
  grand_total?: string
  validity_date_from?: string
  validity_date_to?: string
  sales_org_name?: string
}

export interface IContractState {
  isLoading?: boolean
  isAmendment?: boolean
  error?: string
  soOrders?: Array<any>
  filter?: IFetchOrderContractsParams
  sort?: {
    po_number_orderby: 'asc' | 'desc' | ''
    customer_name_orderby: 'asc' | 'desc' | ''
    checked: boolean
  }
  numberUrls?: Array<string>
  sipFilter: {
    SIP_number?: string
    customer_name?: string
    sector_id?: any
    product_type?: string
  }
  customerFilter: {
    sales_org_code?: string
    customer_code?: string
    name?: string
    distribution_channel?: string
  }
  orderItems: TOrderItemContract[]
  orderItem: TOrderItemContract | null
}

const initialState: IContractState = {
  isLoading: false,
  isAmendment: false,
  error: '',
  soOrders: [],
  sort: {
    po_number_orderby: '',
    customer_name_orderby: '',
    checked: false,
  },
  filter: {
    contract_number: '',
    sip_number: '',
    from_date: '',
    to_date: '',
    sales_org_code: '',
    customer_name: '',
    total_quantum: '',
    product_type: '',
    total_price: '',
    payment_type: '',
    estimate_date: '',
    status: '',
    regarding: '',
    sector_id: '',
    po_number: '',
    sap_number: '',
    validity_date_from: '',
    validity_date_to: '',
    order_sub_id: '',
    per_page: 25,
  },
  numberUrls: [],
  sipFilter: {
    SIP_number: '',
    customer_name: '',
    sector_id: '',
    product_type: '',
  },
  customerFilter: {
    sales_org_code: '',
    customer_code: '',
    name: '',
    distribution_channel: '',
  },
  orderItems: [],
  orderItem: null,
}

/**
 * Slice
 */
const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setContractOrders: (state, action) => ({...state, orders: action.payload}),
    setFilter: (state, action) => ({...state, filter: action.payload}),
    setSort: (state, action) => ({...state, sort: action.payload}),
    setError: (state, action) => ({...state, error: action.payload}),
    setIsLoading: (state, action) => ({...state, isLoading: action.payload}),
    setIsAmandement: (state, action) => ({...state, isAmendment: action.payload}),
    setNumberUrls: (state, action) => ({...state, numberUrls: action.payload}),
    resetFilter: (state) => ({...state, filter: initialState.filter}),
    setSipFilter: (state, action) => ({...state, sipFilter: action.payload}),
    setCustomerFilter: (state, action) => ({...state, customerFilter: action.payload}),
    setOrderItems: (state, action) => ({...state, orderItems: action.payload}),
    setOrderItem: (state: IContractState, action: PayloadAction<TOrderItemContract | null>) => {
      state.orderItem = action.payload
    },
    addOrderItem: (state, action: PayloadAction<TOrderItemContract>) => {
      state.orderItems.push(action.payload)
    },
    delOrderItem: (state: IContractState, action: PayloadAction<number>) => {
      state.orderItems = state.orderItems.filter((_item, index) => {
        return index !== action.payload
      })
    },
    putOrderItem: (state: IContractState, action: PayloadAction<TOrderItemContract>) => {
      const updatedItem = action.payload
      const index = state.orderItems.findIndex((item) => item.id === updatedItem.id)
      state.orderItems[index] = updatedItem
    },
  },
})

/**
 * Action
 */
export const {
  setContractOrders,
  setFilter,
  setSort,
  setError,
  setIsLoading,
  setIsAmandement,
  setNumberUrls,
  resetFilter,
  setSipFilter,
  setCustomerFilter,
  setOrderItems,
  setOrderItem,
  addOrderItem,
  delOrderItem,
  putOrderItem,
} = contractSlice.actions

/**
 * Selector
 */
export const contractSelector = (state: RootState) => state.contractReducer

/**
 * Reducer
 */
export default contractSlice.reducer
